import React from "react";

// Boundaries per spec: 0 → 0 dots; 1-5 → 1 dot; 5-10 → 2 dots; >10 → 3 dots.
// Upper bounds are treated as inclusive to the lower bucket (5 → 1 dot,
// 10 → 2 dots) so every count maps to exactly one bucket.
const filledDots = (count) => {
  const n = Number(count) || 0;
  if (n <= 0) return 0;
  if (n <= 5) return 1;
  if (n <= 10) return 2;
  return 3;
};

/**
 * DemandMeter — 3-dot demand indicator + numeric count.
 * Used for both the Core List "Demand 30d" column and the Insights
 * "Distinct contacts" column so the two tabs read identically.
 *
 * @param {number} count
 * @param {string} [unit="leads"] — label suffix, e.g. "leads" or "contacts"
 */
const DemandMeter = ({ count, unit = "leads" }) => {
  const n = Number(count) || 0;
  const filled = filledDots(n);

  return (
    <span
      className="core-list-demand"
      aria-label={`${n} ${unit} in the last 30 days`}
    >
      <span className="core-list-demand__dots" aria-hidden="true">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className={`core-list-demand__dot${i < filled ? " core-list-demand__dot--on" : ""}`}
          />
        ))}
      </span>
      <span className="core-list-demand__count">{n}</span>
    </span>
  );
};

export default DemandMeter;
